<template>
  <div class="wrapper-page">
    <div class="wrapper-bg-header">
      <!-- <div class="container">
        <h1>มาตรฐานผลิตภัณฑ์ (Product Quality)</h1>
      </div>-->
      <div class="banner-text">
        <div>ติดต่อเรา&nbsp;</div>
        <div style="color: rgb(243, 200, 23); font-weight:700">(Contact Us)</div>
      </div>
    </div>
    <div>
      <div class="container content-container-max-width">
        <img class="img-about" src="/img/about.jpg" />
        <h4>ติดต่อสอบถามข้อมูลได้ที่นี่</h4>
        <div class="address-box">
          <h5>บริษัท แกรนด์สตีล จำกัด</h5>
          <p>92/70 หมู่ที่ 2 ซอยเพชรเกษม 116/4 แขวงหนองค้างพลู เขตหนองแขม กรุงเทพมหานคร 10160</p>
          <p>โทรศัพท์ : 02-431-2439 , 02-431-2440 , 02-431-2349 , 02-431-2350 , 02-431-2833</p>
          <p>แฟกซ์ : 02-431-2718,02-431-2719</p>
          <p>อีเมล : grandsteel@hotmail.co.th</p>
        </div>
        <h4>กรอกรายละเอียดสอบถามข้อมูล</h4>
        <!-- <form
          id="form_contact"
          ref="form"
          @submit.prevent="onSubmit2(firstname, lastname, tel, email, selectProduct, description)"
          class="needs-validation"
          method="POST"
          data-email="Tatthep.atta@gmail.com"
          action="https://script.google.com/macros/s/AKfycbzzH27YkbOrgc_TAjYBMbldqd3lbggXxCKoyeqUU2REwBlfATw/exec"
        >
          <fieldset class="form-group">
            <input
              class="form-control"
              type="text"
              v-model="firstname"
              id="validationCustom01"
              placeholder="ชื่อ"
              required
            />
          </fieldset>
          <fieldset class="form-group">
            <input
              class="form-control"
              type="text"
              v-model="lastname"
              id="validationCustom02"
              placeholder="นามสกุล"
              required
            />
          </fieldset>
          <fieldset class="form-group">
            <input
              class="form-control"
              type="tel"
              v-model="tel"
              id="validationCustom03"
              placeholder="เบอร์โทรศัพท์"
              required
            />
          </fieldset>
          <fieldset class="form-group">
            <input
              class="form-control"
              type="email"
              v-model="email"
              id="validationCustom04"
              placeholder="อีเมล"
              required
            />
          </fieldset>
          <fieldset class="form-group">
            <input
              class="form-control input-readonly"
              id="validationCustom05"
              placeholder="สินค้าที่สนใจ"
              :value="this.selectProduct"
              readonly
              required
            />
            <select
              class="form-control"
              @change="formSelectProduct"
              required
            >
              <option selected disabled>--กรุณาเลือกสินค้าที่สนใจ--</option>
              <option
                v-for="(intro, index) in getAllIntro"
                :key="index"
                :value="intro.name">
                {{intro.name}}
              </option>
            </select>
          </fieldset>
          <fieldset class="form-group">
            <textarea
              class="form-control"
              type="text"
              v-model="description"
              id="validationCustom06"
              placeholder="ข้อความ"
              style="margin"
            />
          </fieldset>
          <button class="btn" type="submit">ส่งข้อมูล</button>
        </form> -->
          <!-- <button class="btn" @click="signOut()">ล็อคเอ้าท์</button> -->
        
        
        <form class="gform pure-form pure-form-stacked" method="POST" data-email="info.grandsteels@gmail.com"
          id="form_contact"
          @submit.prevent="onSubmit2(firstname, lastname, tel, email, selectProduct, description)"
          >
            <!-- change the form action to your script url -->

            <div class="form-elements">
              <fieldset class="form-group pure-group">
                <input
                  class="form-control"
                  type="text"
                  v-model="firstname"
                  id="firstname"
                  name="firstname"
                  placeholder="ชื่อ"
                  required
                />
              </fieldset>
              <fieldset class="form-group pure-group">
                <input
                  class="form-control"
                  type="text"
                  v-model="lastname"
                  id="lastname"
                  name="lastname"
                  placeholder="นามสกุล"
                  required
                />
              </fieldset>
              <fieldset class="form-group pure-group">
                <input
                  class="form-control"
                  type="tel"
                  v-model="tel"
                  placeholder="เบอร์โทรศัพท์"
                  id="tel"
                  name="tel"
                  required
                />
              </fieldset>
              <fieldset class="form-group pure-group">
                <input
                  class="form-control"
                  type="email"
                  v-model="email"
                  id="email"
                  value=""
                  name="email"
                  placeholder="อีเมล"
                  required
                />
              </fieldset>
              <fieldset class="form-group pure-group">
                <input
                  class="form-control input-readonly"
                  id="product"
                  name="product"
                  placeholder="สินค้าที่สนใจ"
                  :value="this.selectProduct"
                  readonly
                  required
                />
                <select
                  class="form-control"
                  @change="formSelectProduct"
                  required
                >
                  <option selected disabled>--กรุณาเลือกสินค้าที่สนใจ--</option>
                  <option
                    v-for="(intro, index) in getAllIntro"
                    :key="index"
                    :value="intro.name">
                    {{intro.name}}
                  </option>
                </select>
              </fieldset>
              <fieldset class="form-group">
                <textarea
                  class="form-control"
                  type="text"
                  v-model="description"
                  id="description"
                  name="description"
                  placeholder="ข้อความ"
                  style="margin"
                />
              </fieldset>

              <fieldset class="pure-group honeypot-field" style="display: none;">
                <label for="honeypot">To help avoid spam, utilize a Honeypot technique with a hidden text field; must be empty to submit the form! Otherwise, we assume the user is a spam bot.</label>
                <input id="honeypot" type="text" name="honeypot" value="" />
              </fieldset>

              <button class="btn button-success pure-button button-xlarge">
                <i class="fa fa-paper-plane"></i>&nbsp;ส่งข้อมูล</button>
            </div>

            <!-- Customise the Thankyou Message People See when they submit the form: -->
            <div class="thankyou_message" style="display:none;">
              <h2><em>Thanks</em> for contacting us!
                We will get back to you soon!</h2>
            </div>

          </form>

          <p>
            <b>**หมายเหตุ:</b>เมื่อท่านส่งข้อมูลผ่านฟอร์ม จะถือว่าท่านยอมรับในนโยบายความเป็นส่วนตัวของเรา
          </p>
      </div>
    </div>
    <popup-form v-if="isPopup"></popup-form>
  </div>
</template>


<script>
import service from "@/services/service.js";
import { mapGetters } from "vuex";
import axios from "axios";
export default {
  name: "Catalog",
  data() {
    return {
      isPopup: false,
      firstname: null,
      lastname: null,
      tel: null,
      email: null,
      selectProduct: "",
      description: null
    };
  },
  computed: {
    ...mapGetters(["getAllIntro"]),
  },
  mounted() {
    this.handleClientLoad();
  },
  methods: {
    formSelectProduct (e) {
      if (e.target && e.target.value) {
        if (this.selectProduct.length > 0) {
          this.selectProduct = this.selectProduct+", "+e.target.value
        } else {
          this.selectProduct = this.selectProduct+e.target.value
        }
      }
    },
    handleClientLoad() {
      gapi.load("client:auth2", this.initClient);
    },
    initClient() {
      //provide the authentication credentials you set up in the Google developer console

      const CLIENT_ID =
        "1073886515332-dss5a2pjgmp3lh2ovduvvg74nka5to8e.apps.googleusercontent.com"; //from https://console.developers.google.com/apis/credentials
      const API_KEY = "AIzaSyBNnTUnyHWRJLOilb3KryOfqWCLXxqKjR4"; //https://console.developers.google.com/apis/credentials
      const SCOPE = "https://www.googleapis.com/auth/spreadsheets";

      gapi.client
        .init({
          apiKey: API_KEY,
          clientId: CLIENT_ID,
          scope: SCOPE,
          ux_mode: "redirect",
          redirect_uri: window.location.origin + "/contact",
          discoveryDocs: [
            "https://sheets.googleapis.com/$discovery/rest?version=v4"
          ]
        })
        .then((response) => {
          // console.log(
          //   "isSignedIn :",
          //   gapi.auth2.getAuthInstance().isSignedIn.get()
          // );
          // if (gapi.auth2.getAuthInstance().isSignedIn.get() == false) {
          //   gapi.auth2.getAuthInstance().signIn();
          //   console.log("response :", response);
          // }
          // gapi.auth2.getAuthInstance().isSignedIn.listen(this.updateSignInStatus); //add a function called `updateSignInStatus` if you want to do something once a user is logged in with Google
          // this.updateSignInStatus(gapi.auth2.getAuthInstance().isSignedIn.get());
        });
    },
    signOut() {
      gapi.auth2.getAuthInstance().signOut();
    },
    onSubmit2(firstname, lastname, tel, email, selectProduct, description) {
      // POST request using axios with set headers
  // const article = { title: "Vue POST Request Example" };
  // const headers = {
  //   "Access-Control-Allow-Origin": "domain-a.com",
  //   "Access-Control-Allow-Methods": "POST, GET, PUT, PATCH, DELETE, OPTIONS",
  //   "Access-Control-Allow-Headers": "Content-Type, Option, Authorization"
  // };
  // var data = {
  //   firstname: firstname,
  //   lastname: lastname,
  //   tel: tel,
  //   email: email,
  //   product: selectProduct,
  //   description: description,
  //   formDataNameOrder: '["firstname","lastname","tel","email","product","description"]',
  //   formGoogleSendEmail: "Info.grandsteels@gmail.com",
  //   formGoogleSheetName: "responses",
  // }
  // axios.post("https://script.google.com/macros/s/AKfycbzzH27YkbOrgc_TAjYBMbldqd3lbggXxCKoyeqUU2REwBlfATw/exec", data, { headers })
  //   .then(response => {
  //       form.reset();
  //           window.alert("success");
  //         });

// var data = {
//         firstname: firstname,
//         lastname: lastname,
//         tel: tel,
//         email: email,
//         product: selectProduct,
//         description: description,
//       }
      
//       var url = "https://script.google.com/macros/s/AKfycbzzH27YkbOrgc_TAjYBMbldqd3lbggXxCKoyeqUU2REwBlfATw/exec";
//       var form = document.getElementById("form_contact");
//       // url encode form data for sending as post data
//       var encoded = Object.keys(data).map((k) => {
//           return encodeURIComponent(k) + "=" + encodeURIComponent(data[k]);
//       }).join('&');
//       url = url + '?' + encoded;
//       var xhr = new XMLHttpRequest();
//       xhr.open('POST', url);
//       // xhr.withCredentials = true;
//       // xhr.setRequestHeader("Content-Type", "application/x-www-form-urlencoded");
//       xhr.setRequestHeader("Access-Control-Allow-Origin", "*");
//       xhr.setRequestHeader("Access-Control-Allow-Methods", "POST, GET, PUT, PATCH, DELETE, OPTIONS");
//       xhr.setRequestHeader("Access-Control-Allow-Headers", "Content-Type, Option, Authorization");
//       xhr.onreadystatechange = () => {
//           if (xhr.readyState === 4 && xhr.status === 200) {
//             form.reset();
//             window.alert("success");
//           }
//       };
      
//       xhr.send();
    
      var form = document.getElementById("form_contact");
      // var form = event.target;
      var formData = this.getFormData(form);
      var data = formData.data;

      // If a honeypot field is filled, assume it was done so by a spam bot.
      if (formData.honeypot) {
        return false;
      }

      // disableAllButtons(form);
      // var url = form.action
      var url = "https://script.google.com/macros/s/AKfycbzzH27YkbOrgc_TAjYBMbldqd3lbggXxCKoyeqUU2REwBlfATw/exec";
      var xhr = new XMLHttpRequest();
      var previousLink = "";
      previousLink += window.location.href;
      xhr.open('POST', url);
      // xhr.withCredentials = true;
      xhr.setRequestHeader("Content-Type", "application/x-www-form-urlencoded");
      xhr.onreadystatechange = function() {
          if (xhr.readyState === 4 && xhr.status === 200) {
            form.reset();

        // pixel
        !function(f,b,e,v,n,t,s)
        {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
        n.callMethod.apply(n,arguments):n.queue.push(arguments)};
        if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
        n.queue=[];t=b.createElement(e);t.async=!0;
        t.src=v;s=b.getElementsByTagName(e)[0];
        s.parentNode.insertBefore(t,s)}(window, document,'script',
        'https://connect.facebook.net/en_US/fbevents.js');
        fbq('init', '2696293753940191');
        fbq('track', 'LoginView');

        window.alert("ข้อมูลได้ถูกจัดส่งเรียบร้อย")
            
          }
      };
      // url encode form data for sending as post data
      var encoded = Object.keys(data).map(function(k) {
          return encodeURIComponent(k) + "=" + encodeURIComponent(data[k]);
      }).join('&');
      xhr.send(encoded);

      
    },
    onSubmit(firstname, lastname, tel, email, selectProduct, description) {
      // if isn't signin, let signin google acccount
      if (!gapi || !gapi.auth2 || !gapi.auth2.getAuthInstance() || !gapi.auth2.getAuthInstance().isSignedIn || !gapi.auth2.getAuthInstance().isSignedIn.get()) {
        gapi.auth2.getAuthInstance().signIn();
      }
      const SPREADSHEET_ID = "1k6UXhd0Ahx77uHGUA4vGUmHBTQ5C0mwYQwQWtXeWQuY"; //from the URL of your blank Google Sheet
      let data = [[firstname], [lastname], [tel], [email], [selectProduct], [description]];
      // console.log("data : ", data);

      const params = {
        spreadsheetId: SPREADSHEET_ID,
        range: "form", //this is the default spreadsheet name, so unless you've changed it, or are submitting to multiple sheets, you can leave this
        valueInputOption: "RAW", //RAW = if no conversion or formatting of submitted data is needed. Otherwise USER_ENTERED
        insertDataOption: "INSERT_ROWS" //Choose OVERWRITE OR INSERT_ROWS
      };

      const valueRangeBody = {
        majorDimension: "COLUMNS", //log each entry as a new row (vs column)
        values: data //convert the object's values to an array
      };

      let request = gapi.client.sheets.spreadsheets.values.append(
        params,
        valueRangeBody
      );
      request.then(
        (response) => {
          // TODO: Insert desired response behaviour on submission
          // console.log(response.result);
          
          window.alert("ข้อมูลได้ถูกจัดส่งเรียบร้อย")
          this.$refs.form.reset();
          this.firstname = "";
          this.lastname = "";
          this.tel = "";
          this.email = "";
          this.selectProduct = "";
          this.description = "";
        },
        (response) => {
          // console.error("error: " + reason.result.error.message);

          window.alert("ข้อมูลได้ถูกจัดส่งเรียบร้อย")
          this.$refs.form.reset();
          this.firstname = "";
          this.lastname = "";
          this.tel = "";
          this.email = "";
          this.selectProduct = "";
          this.description = "";
        }
      );
    },
    openPopupForm() {
      this.isPopup = !this.isPopup;
    },
    getFormData (form) {
      var elements = form.elements;
      var honeypot;

      var fields = Object.keys(elements).filter(function(k) {
        if (elements[k].name === "honeypot") {
          honeypot = elements[k].value;
          return false;
        }
        return true;
      }).map(function(k) {
        if(elements[k].name !== undefined) {
          return elements[k].name;
        // special case for Edge's html collection
        }else if(elements[k].length > 0){
          return elements[k].item(0).name;
        }
      }).filter(function(item, pos, self) {
        return self.indexOf(item) == pos && item;
      });

      var formData = {};
      fields.forEach(function(name){
        var element = elements[name];
        
        // singular form elements just have one value
        formData[name] = element.value;

        // when our element has multiple items, get their values
        if (element.length) {
          var data = [];
          for (var i = 0; i < element.length; i++) {
            var item = element.item(i);
            if (item.checked || item.selected) {
              data.push(item.value);
            }
          }
          formData[name] = data.join(', ');
        }
      });

      // add form-specific values into the data
      formData.formDataNameOrder = JSON.stringify(fields);
      formData.formGoogleSheetName = form.dataset.sheet || "responses"; // default sheet name
      formData.formGoogleSendEmail
        = form.dataset.email || ""; // no email by default

      return {data: formData, honeypot: honeypot};
    }
  }
};
</script>

<style scoped>
.form-control {
  width: 80%;
}
.needs-validation {
  margin-bottom: 15px;
}
.invalid-feedback {
  display: block;
}
.btn {
  border: 2px solid rgb(243, 200, 23);
  background-color: transparent;
}
.btn:hover {
  background-color: rgb(243, 200, 23);
}

table {
  margin-top: 10px;
}

h4 {
  margin-top: 30px !important;
  font-weight: 600;
}

.img-about {
  margin: auto;
  /* margin-bottom: 30px; */
  width: 100%;
  max-width: 960px;
  animation: size 0.5s;
}

@keyframes fade {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

.banner-page {
  display: flex;
  flex-direction: row;
  justify-content: space-evenly;
}

.address-box {
  border-width: 2px;
  max-width: 500px;
  display: flex;
  flex-direction: column;
  justify-content: space-evenly;
  padding: 15px;
  /* color: rgb(255, 255, 255); */
  border: 2px solid rgb(243, 200, 23); /* Green */
  /* background-color: transparent; */
  border-radius: 10px;
}

p {
  margin-bottom: 8px;
}

.input-readonly  {
  color: #55595c;
  background-color: #fff;
  cursor: initial;
}

select {
  cursor: pointer;
}
</style>